import React from 'react';
import qs from 'qs';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoadingDots } from '@joinclyde/clyde-react-components';
import { checkSkeletonKey } from '../../actions/authActions';

class SkeletonKey extends React.Component {
  componentDidMount() {
    const query = this.props.location.search.slice(1);
    this.props._checkSkeletonKey(qs.parse(query));
  }

  componentDidUpdate() {
    if (this.props.authed === true) {
      setTimeout(() => {
        window.location = '/';
      }, 2000);
    }
  }

  render() {
    return (
      <div className='gradient'>
        <LoadingDots dotColor='clydeBlack' dotSize='large' />
      </div>
    );
  }
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { _checkSkeletonKey: checkSkeletonKey },
  dispatch,
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SkeletonKey));
